import { SUPPORTED_VALUES, TimelineEvent } from "../Timeline/Types";
import { useMemo } from "react";

export type TeamGoalsType = {
    playerName: string;
    time: string;
};

export function useGameGoals(timeline: TimelineEvent[]) {
    const [teamHomeGoals, teamAwayGoals] = useMemo(() => {
        const teamAwayGoals: TeamGoalsType[] = [];
        const teamHomeGoals: TeamGoalsType[] = [];
        timeline.forEach((event) => {
            if (event.type === SUPPORTED_VALUES.SCORE_CHANGE) {
                const playerName = event.players?.find(
                    (player) => player.type === "scorer",
                )?.displayLastName;

                if (playerName === undefined) {
                    return;
                }
                const goalTime = event.matchTime;

                const teamGoalsArray =
                    event.teamType === "home" ? teamHomeGoals : teamAwayGoals;

                const goal = teamGoalsArray.find(
                    (goal) => goal.playerName === playerName,
                );

                if (goal) {
                    goal.time = goal.time + `, ${goalTime}'`;
                } else {
                    teamGoalsArray.push({
                        playerName: playerName,
                        time: `${goalTime}'`,
                    });
                }
            }
        });
        return [teamHomeGoals, teamAwayGoals];
    }, [timeline.length]);

    return { teamAwayGoals, teamHomeGoals };
}
